import { useCallback, useEffect } from "react";
import useActiveCallsStore from "./store";
import {
  deletePendingCalls,
  getCurrentQueueStats,
  putPausePendingCalls,
  putQueuePausedCalls,
  deletePausedCalls
} from "V2.0/services/outboundCommunication";

export default function useActiveCallsState(workspaceId, assistantId) {
  const { state, updateActiveCallStats, updateIsLoading } =
    useActiveCallsStore();

  const fetchCurrentQueueStats = useCallback(
    async function () {
      updateIsLoading(true);

      try {
        const response = await getCurrentQueueStats({
          workspaceId,
          assistantId,
        });

        if (response.status === 200) {
          const { data } = response.data;
          updateActiveCallStats(data);
        }
      } catch (e) {
        updateIsLoading(false);
      }
    },
    [workspaceId, assistantId]
  );

  const cancelPendingCalls = useCallback(
    async function (lifecycleCbs) {
      lifecycleCbs.init();

      try {
        const response = await deletePendingCalls({ workspaceId, assistantId });
        if (response.status === 200) {
          lifecycleCbs.success(response.data);
        }
      } catch (e) {
        lifecycleCbs.error(e);
      }
    },
    [workspaceId, assistantId]
  );

  const pausePendingCalls = useCallback(
    async function (lifecycleCbs) {
      lifecycleCbs.init();

      try {
        const response = await putPausePendingCalls({
          workspaceId,
          assistantId,
        });

        if (response.status === 200) {
          lifecycleCbs.success(response.data);
        }
      } catch (e) {
        lifecycleCbs.error(e);
      }
    },
    [workspaceId, assistantId]
  );

  const queuePausedCalls = useCallback(
    async function (lifecycleCbs) {
      lifecycleCbs.init();

      try {
        const response = await putQueuePausedCalls({
          workspaceId,
          assistantId,
        });

        if (response.status === 200) {
          lifecycleCbs.success(response.data);
        }
      } catch (e) {
        lifecycleCbs.error(e);
      }
    },
    [workspaceId, assistantId]
  );

  const cancelPausedCalls = useCallback(
    async function (lifecycleCbs) {
      lifecycleCbs.init();

      try {
        const response = await deletePausedCalls({
          workspaceId,
          assistantId,
        });

        lifecycleCbs.success(response.data);
      } catch (e) {
        lifecycleCbs.error(e);
      }
    },
    [workspaceId, assistantId],
  );

  useEffect(function () {
    fetchCurrentQueueStats();
  }, []);

  return {
    state,
    fetchCurrentQueueStats,
    cancelPendingCalls,
    pausePendingCalls,
    queuePausedCalls,
    cancelPausedCalls
  };
}
